

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      //  Add to cart event
      onSubmitHandler(evt) {
        console.log("submit")
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let formData = new FormData(this.form);

        // ---- 🔹 FILTER LINE ITEM PROPERTIES BASED ON qr_flag ----
        // Remove all line item properties first
        for (let key of Array.from(formData.keys())) {
          if (key.startsWith('properties[')) {
            formData.delete(key);
          }
        }

        if (qr_flag) {
          // QR mode: keep only phone + qr text input
          const qrPhone = document.getElementById('qr-code-phone-text-input')?.value.trim();
          const qrText = document.getElementById('qr-text-input')?.value.trim();
          const qrText2 = document.getElementById('qr-text-input-2')?.value.trim();

          

          if (qrPhone) formData.append('properties[QR Phone]', qrPhone);
          if (qrText) formData.append('properties[QR Text]', qrText);
          if (qrText2) formData.append('properties[QR Text 2]', qrText2);

        } else {
          // No QR mode: keep only icon + text lines
          const fields = [
            { id: 'fabric-text-icons-1-no-qr', label: 'Text 1' },
            { id: 'fabric-text-line-1-no-qr', label: 'Text 2' },
            { id: 'fabric-text-line-2-no-qr', label: 'Text 3' },
            { id: 'fabric-text-line-3-no-qr', label: 'Text 4' },
            { id: 'fabric-text-line-4-no-qr', label: 'Text 5' },
          ];

          fields.forEach(f => {
            const val = document.getElementById(f.id)?.value.trim();
            if (val) formData.append(`properties[${f.label}]`, val);
          });
        }
        // ---- 🔹 END FILTER ----

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      //  Handle error
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

    }
  );

  // QR Modes Selectors Buttons
  const noQrBtn = document.getElementById('no-qr-mode-btn');
  const qrBtn = document.getElementById('qr-mode-btn');
  const textInfo = document.getElementById('text-icon-info');
  const qrInfo = document.getElementById('qr-info');
  let qr_flag = false;


  // No QR Mode Button
noQrBtn.addEventListener('click', function (event) {
  event.preventDefault();

  // If already selected, do nothing
  if (noQrBtn.classList.contains('selected')) return;

  qr_flag = false;
 
  // Toggle button classes
  qrBtn.classList.remove('selected');
  noQrBtn.classList.add('selected');

  // Toggle info sections
  qrInfo.classList.remove('selected');
  textInfo.classList.add('selected');

  // Show relevant sections
  document.querySelectorAll('#fabric-icon-text-no-qr-cont, #fabric-text-only-no-qr-cont, #icons-keyboard')
    .forEach(el => el.classList.add('show'));

  // Hide QR sections
  document.querySelectorAll('#qr-code-phone-generator, #generate-qr-btn, #qr-code-image, #qr-code-text-line-cont, #qr-code-text-line-cont-2')
    .forEach(el => el.classList.remove('show'));

  // Clear the Qr mode text fields
    ['qr-code-phone-text-input','qr-text-input','qr-text-input-2'].forEach(id => { 
      const el = document.getElementById(id); if (el) el.value = ''; });
    
});

// QR Mode Button
qrBtn.addEventListener('click', function (event) {
  event.preventDefault();

  // If already selected, do nothing
  if (qrBtn.classList.contains('selected')) return;

  qr_flag = true;

  // Toggle button classes
  noQrBtn.classList.remove('selected');
  qrBtn.classList.add('selected');

  // Toggle info sections
  textInfo.classList.remove('selected');
  qrInfo.classList.add('selected');

  // Show QR sections
  document.querySelectorAll('#qr-code-phone-generator, #generate-qr-btn, #qr-code-image, #qr-code-text-line-cont, #qr-code-text-line-cont-2')
    .forEach(el => el.classList.add('show'));

  // Hide non-QR sections
  document.querySelectorAll('#fabric-icon-text-no-qr-cont, #fabric-text-only-no-qr-cont, #icons-keyboard')
    .forEach(el => el.classList.remove('show'));

  // Clear the non-qr text fields
    ['fabric-text-icons-1-no-qr','fabric-text-line-1-no-qr','fabric-text-line-2-no-qr','fabric-text-line-3-no-qr','fabric-text-line-4-no-qr'].forEach(id => { 
      const el = document.getElementById(id); if (el) el.value = ''; });


});

// // Keyboard Buttons Event
// document.querySelectorAll('#medical-icons-keyboard button, #fun-icons-keyboard button').forEach(button => {
//   button.addEventListener('click', function (event) {
//     event.preventDefault();

//     // Select input depending on current mode
//     const input = qr_flag
//       ? document.getElementById('qr-text-input')        // QR mode
//       : document.getElementById('fabric-text-icons-1-no-qr'); // No QR mode

//     const value = this.textContent;
//     input.value += value;
//     enforceMaxLength8(input);  /// CHANGE FOR QR 1ST TEXT LINE
//     //input.value = input.value.toUpperCase();
//     input.focus();
//   });
// });

// document.querySelectorAll('#medical-icons-keyboard button, #fun-icons-keyboard button').forEach(button => {
//   button.addEventListener('click', function (event) {
//     event.preventDefault();

//     // Select input depending on current mode
//     const input = qr_flag
//       ? document.getElementById('qr-text-input')        // QR mode
//       : document.getElementById('fabric-text-icons-1-no-qr'); // No QR mode

//     const value = this.textContent;

//     // Get caret positions
//     const start = input.selectionStart;
//     const end   = input.selectionEnd;

//     // Insert at caret
//     const before = input.value.substring(0, start);
//     const after  = input.value.substring(end);

//     input.value = before + value + after;

//     // Move caret after the inserted character
//     const newPos = start + value.length;
//     input.setSelectionRange(newPos, newPos);

//     // Your max length logic
//     enforceMaxLength8(input); // adjust depending on QR or fabric field

//     input.focus();
//   });
// });

  // Prevent Letters characters from being entered into the TEL input
    const phoneInput = document.getElementById("qr-code-phone-text-input");
    
    phoneInput.addEventListener("input", function () {
      // Keep only digits and "+"
      let val = this.value.replace(/[^0-9+]/g, "");

      // Limit to max 16 characters
      this.value = val.slice(0, 17);
    });


  // QR Code Generation Code
    setTimeout(function () {
      var qrcode = new QRCode(document.getElementById("qr-code-image"), {
        width: 158,
        height: 158
      });

      document.getElementById("generate-qr-btn").addEventListener("click", function (event) {
        event.preventDefault();
        var text = document.getElementById("qr-code-phone-text-input").value;
        if (text.trim() === "") {
          alert("Please enter your phone number");
          document.getElementById("qr-code-phone-text-input").focus();
          return;
        }
        document.querySelector("#qr-code-image span").classList.add("hide");
        qrcode.makeCode(text);
      });

    }, 2000);

  // Utility functions to enforce max length (max 5 or max 16 characters) and flash red
    function enforceMaxLength16(input) {
      if (input.value.length > 24) {
        input.value = input.value.slice(0, 24); // trim extra
        input.style.color = "red"; // flash red
        setTimeout(() => {
          input.style.color = "";
        }, 200);
      } else {
        input.style.color = "";
      }
    }

    function enforceMaxLength5(input) {
      if (input.value.length > 5) {
        input.value = input.value.slice(0, 5); // trim extra
        input.style.color = "red";
        setTimeout(() => {
          input.style.color = "";
        }, 200);
      } else {
        input.style.color = "";
      }
    }

    function enforceMaxLength8(input) {
      if (input.value.length > 12) {
        input.value = input.value.slice(0, 12); // trim extra
        input.style.color = "red";
        setTimeout(() => {
          input.style.color = "";
        }, 200);
      } else {
        input.style.color = "";
      }
    }

    function enforceMaxLength18(input) {
      if (input.value.length > 18) {
        input.value = input.value.slice(0, 18); // trim extra
        input.style.color = "red";
        setTimeout(() => {
          input.style.color = "";
        }, 200);
      } else {
        input.style.color = "";
      }
    }

  

  // Handle typing/pasting

    // qr-text-input 8 /// CHANGE FOR QR 1ST TEXT LINE
    ['qr-text-input'].forEach(id => {
      const input = document.getElementById(id);
      input.addEventListener('input', function () {
        enforceMaxLength8(this);
        //this.value = this.value.toUpperCase();
      });
    });

    // qr-text-input-2 18 /// CHANGE FOR QR 2ND TEXT LINE
    ['qr-text-input-2'].forEach(id => {
      const input = document.getElementById(id);
      input.addEventListener('input', function () {
        enforceMaxLength18(this);
        //this.value = this.value.toUpperCase();
      });
    });


    ['fabric-text-line-1-no-qr', 'fabric-text-line-2-no-qr', 'fabric-text-line-3-no-qr', 'fabric-text-line-4-no-qr'].forEach(id => {
      const input = document.getElementById(id);
      input.addEventListener('input', function () {
        enforceMaxLength16(this);
        //this.value = this.value.toUpperCase();
      });
    });

    ['fabric-text-icons-1-no-qr'].forEach(id => {
      const input = document.getElementById(id);
      input.addEventListener('input', function () {
        enforceMaxLength8(this);
        //this.value = this.value.toUpperCase();
      });
    });
}
